module.exports = __webpack_public_path__ + "img/Review_text05_mainpoints.4a2e1581.png";